// extracted by mini-css-extract-plugin
export default {"cvError":"R8-z"};